import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import DeleteEventDataPage from "./pages/DeleteEventDataPage";
import ExpressionRecognitionPage from "./pages/ExpressionRecognitionPage";
import ExpressionReportPage from "./pages/ExpressionReportPage";
import FaceCollectorAwsPage from "./pages/FaceCollectorAwsPage";
import FaceCollectorAwsV2Page from "./pages/FaceCollectorAwsV2Page";
import FaceCollectorAwsV3Page from "./pages/FaceCollectorAwsV3Page";
import FaceCollectorByPhotoPage from "./pages/FaceCollectorByPhotoPage";
import FaceCollectorPage from "./pages/FaceCollectorPage";
import FaceScanOfflinePage from "./pages/FaceScanOfflinePage";
import FaceScanPage from "./pages/FaceScanPage";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import RecoverPasswordPage from "./pages/RecoverPasswordPage";

const RoutesProp = (props) => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="*" element={<Navigate to="/Login" replace={true} />} />
        <Route path="/DeleteEventData" element={<DeleteEventDataPage />} />
        <Route
          path="/ExpressionRecognition"
          element={<ExpressionRecognitionPage />}
        />
        <Route path="/ExpressionReport" element={<ExpressionReportPage />} />
        <Route path="/FaceCollectorAws" element={<FaceCollectorAwsPage />} />
        <Route
          path="/FaceCollectorAwsV2"
          element={<FaceCollectorAwsV2Page />}
        />
        <Route
          path="/FaceCollectorAwsV3"
          element={<FaceCollectorAwsV3Page />}
        />
        <Route
          path="/FaceCollectorByPhoto"
          element={<FaceCollectorByPhotoPage />}
        />
        <Route path="/FaceCollector" element={<FaceCollectorPage />} />
        <Route path="/FaceScanOffline" element={<FaceScanOfflinePage />} />
        <Route path="/FaceScan" element={<FaceScanPage />} />
        <Route path="/Home" element={<HomePage />} />
        <Route index path="/Login" element={<LoginPage />} />
        <Route path="/RecoverPassword" element={<RecoverPasswordPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default RoutesProp;
